import { routeConstants } from "constants/routeConstants";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "slice";
import { setIsAgency, setUser, useGetUserProfileDataQuery } from "slice/user";
import { logoutUser } from "slice/userAuth";
import { Agency, ProfileData } from "./types";

export const useProfile = () => {
    const user = useAppSelector((state) => state.userAuth);
    const { userId } = useParams();

    const {
        data: profileData,
        isFetching: isUserDataFetching,
        isSuccess,
    } = useGetUserProfileDataQuery(
        {
            user_id: userId || user.user_id,
        },
        {
            refetchOnMountOrArgChange: true,
        }
    );

    const data: ProfileData = profileData?.data.attributes;

    const [isLoading, setIsLoading] = useState(true);

    const dispatch = useDispatch(),
        navigateTo = useNavigate();

    const arePersonalDetailsFilled = (data: ProfileData) => {
        if (
            !data.gender ||
            !data.nationality ||
            !data.dob ||
            !data.qualification ||
            data.social_links.length === 0
        ) {
            return false;
        } else return true;
    };

    const isAgencyDetailsFilled = (data?: Agency) => {
        if (
            !data ||
            !data.address ||
            !data.details ||
            !data.name ||
            !data.status ||
            !data.website
        ) {
            return false;
        } else return true;
    };

    useEffect(() => {
        const navigateToTalentProfile = () => {
            navigateTo(
                routeConstants.profile.editProfile.root +
                    routeConstants.profile.editProfile.personalDetails,
                {
                    state: {
                        showToast: true,
                    },
                }
            );
        };

        const navigateToAgencyProfile = () => {
            navigateTo(
                routeConstants.profile.editProfile.agency.root +
                    routeConstants.profile.editProfile.agency.companyDetails
            );
        };

        if (
            isSuccess &&
            data.roles.findIndex((i) => i.name === "agency") >= 0
        ) {
            dispatch(setIsAgency(true));
            if (!isAgencyDetailsFilled(data.agency)) {
                navigateToAgencyProfile();
            } else {
                navigateTo(routeConstants.agencyInformation);
            }
        } else if (
            (!data && isSuccess) ||
            (isSuccess && !arePersonalDetailsFilled(data))
        ) {
            dispatch(setIsAgency(false));
            navigateToTalentProfile();
        }
        if (data) {
            setTimeout(() => setIsLoading(false), 1000);
        } else {
            logoutUser();
        }
    }, [data, navigateTo, isSuccess, dispatch]);

    useEffect(() => {
        if (data) {
            dispatch(
                setUser({
                    ...data,
                })
            );
        }
    }, [dispatch, data]);

    useEffect(() => {
        if (isUserDataFetching) {
            setIsLoading(true);
        }
    }, [isUserDataFetching]);

    return {
        data,
        isLoading,
        isSuccess,
    };
};
